module.exports = __webpack_public_path__ + "assets/img/vestamosnoaiq_desconto_black-story.ec3e939e.png";